import { Vue, Component, Prop } from 'vue-property-decorator'
import Checkbox from '~/components/element/Checkbox'
import RemoveSvg from '~/assets/svg/basket-remove.svg?inline'
import s from '~/utils/s'
import NotificationType from '~/types/enum/NotificationType'

@Component
export default class BasketHeader extends Vue {
  @Prop({ type: Boolean, default: true})
  readonly isShowBasketClearButtons: boolean = true

  get isSelected (): boolean {
    return s(this.$store).basket.items.length === s(this.$store).basket.selectedIds.length
  }

  get isHaveProducts () {
    return s(this.$store).basket.items.length > 0
  }

  get header () {
    return 'Корзина'
  }

  select (val: boolean) {
    if (val) {
      s(this.$store).basket.selectAll()
    } else if (this.isSelected) {
      s(this.$store).basket.unselectAll()
    }
  }

  async removeAll () {
    if (s(this.$store).basket.selectedIds.length > 0) {
      await s(this.$store).basket.removeRows(s(this.$store).basket.selectedIds)
    } else {
      s(this.$store).notification.addNotification({
        type: NotificationType.Warning,
        text: 'Для удаления выберите товар'
      })
    }
  }

  render () {
    return (
      <div class="basket-header">
        <div class="basket-header__row">
          <div class="basket-header__col-header">
            <h1 class="basket-header__header">
              {this.header}
            </h1>
          </div>
          {this.isHaveProducts && this.isShowBasketClearButtons &&
            <div class="basket-header__col-checkbox">
              <div class="basket-header__select-all">
                <Checkbox {...{
                  props: {
                    text: 'Выбрать все',
                    value: this.isSelected,
                    name: 'selected_all',
                    label: 'selected_all',
                    rules: {}
                  },
                  on: {
                    change: this.select
                  },
                  scopedSlots: {
                    textPayload: () => 'Выбрать все'
                  }
                }} />
              </div>
              <div class="basket-header__remove-all" onClick={this.removeAll}>
                <div class="basket-header__remove-all-logo">
                  <RemoveSvg />
                </div>
                <div class={{
                  'basket-header__remove-all-text': true,
                  'basket-header__remove-all-text_active': s(this.$store).basket.selectedIds.length > 0
                }}>
                  Удалить выбранные
                </div>
              </div>
            </div>
          }
          {this.isHaveProducts && this.isShowBasketClearButtons &&
            <div class="basket-header__col-checkbox basket-header__col-checkbox_modile">
              <div class="basket-header__select-all-mobile" onClick={() => this.select(!this.isSelected)}>
                Выбрать все
              </div>
              <div class="basket-header__remove-all-mobile" onClick={this.removeAll}>
                Удалить выбранные
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}
